import { motion } from "framer-motion";
import { systemBlack, systemWhite } from "../../constants";
import { createStyledElement } from "../../../../utils/createStyledElement";

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

export const AdditionalSectionContent = createStyledElement(motion.section, () => ({
  backgroundColor: systemWhite,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: isMobileViewport() ? 0 : "50px 40px",
  overflow: "hidden",
}));

export const AdditionalSectionContainer = createStyledElement("div", () => ({
  padding: isMobileViewport() ? "32px 14px" : "48px 10px",
  width: "100%",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  border: "1px solid #D9D9D933",
  backgroundColor: "#FAFBFF",
  flexDirection: isMobileViewport() ? "column" : "row",
  gap: isMobileViewport() ? 25 : 0,
  boxSizing: "border-box",
}));

export const AdditionalSectionTitle = createStyledElement("span", () => ({
  font: isMobileViewport()
    ? '700 24px/28px "Roboto", sans-serif'
    : '700 30px/42px "Roboto", sans-serif',
  color: systemBlack,
  textAlign: isMobileViewport() ? "center" : "left",
  width: "100%",
}));
